import {
  Directive,
  ElementRef,
  HostListener,
  Injector,
  Input
} from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appTwoDigitDecimalNumber]'
})
export class TwoDigitDecimalNumberDirective {
  private control: NgControl | null = null;
  private regex: RegExp = /^\d{0,8}(\.\d{0,2})?$/;
  private specialKeys: string[] = [
    'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
    'Home', 'End', 'ArrowLeft', 'ArrowRight',
    'Clear', 'Copy', 'Paste'
  ];

  constructor(private el: ElementRef, injector: Injector) {
    try {
      this.control = injector.get(NgControl);
    } catch (e) {
      this.control = null;
    }
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (
      this.specialKeys.includes(event.key) ||
      (event.ctrlKey || event.metaKey) &&
      ['a', 'c', 'v', 'x', 'z'].includes(event.key.toLowerCase())
    ) {
      return;
    }

    const input = this.el.nativeElement;
    const current: string = input.value;
    const position = input.selectionStart;
    const next: string = [
      current.slice(0, position),
      event.key === 'Decimal' ? '.' : event.key,
      current.slice(position)
    ].join('');

    if (!this.regex.test(next)) {
      event.preventDefault();
    }
  }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = this.el.nativeElement;
    const value = input.value;

    if (!this.regex.test(value)) {
      input.value = value.slice(0, -1);
    }
  }

  @HostListener('blur')
  onBlur() {
    const input = this.el.nativeElement;
    let value = input.value?.trim();
    if (!value || isNaN(value)) {
      input.value = null;
      this.control?.control?.setValue(null);
      return;
    }
    const formatted = parseFloat(value).toFixed(2);
    input.value = formatted;
    this.control?.control?.setValue(formatted);
  }
  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    let pasted = event.clipboardData?.getData('text/plain') || '';
    pasted = pasted.replace(/[^\d.]/g, '');

    const [intPart, decPart = ''] = pasted.split('.');
    const trimmedInt = intPart.slice(0, 8);
    const trimmedDec = decPart.slice(0, 2);
    const formatted = `${trimmedInt}.${trimmedDec.padEnd(2, '0')}`;
    const final = parseFloat(formatted).toFixed(2);

    document.execCommand('insertText', false, final);
    this.control?.control?.setValue(final);
  }
}
